<div class="table-container scroll-table mat-elevation-z2">
  <div class="mat-table">
    <mat-table
      class="behavior-codes-reactions-table mat-table"
      [dataSource]="dataSource"
      [ngStyle]="{'min-width': '0px'}"
      matSort
      matSortDisableClear>
      <!-- NAME COLUMN -->
      <ng-container matColumnDef="{{columns.NAME}}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.NAME}}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.reaction?.name }} </mat-cell>
      </ng-container>

      <!-- POINTS COLUMN -->
      <ng-container matColumnDef="{{columns.POINTS}}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.POINTS}}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.points }} </mat-cell>
      </ng-container>

      <!-- TRIGGER AT COLUMN -->
      <ng-container matColumnDef="{{columns.TRIGGER_AT}}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.TRIGGER_AT}}
        </mat-header-cell>
        <mat-cell *matCellDef="let row" [matTooltip]="row.triggerCount == null ? 'Reaction will be inside a menu and can be assign at any amount of tracks' : ''" matTooltipPosition="above">
          {{ (row["triggerCount"] !== 0 ? row["triggerCount"] : "default") || "Any" }}
        </mat-cell>
      </ng-container>

      <!-- PRINT COPIES COLUMN -->
      <ng-container matColumnDef="{{columns.PRINT_COPIES}}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.PRINT_COPIES}}
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.printCopies }} </mat-cell>
      </ng-container>

      <!-- ACTION REPEAT COLUMN -->
      <ng-container matColumnDef="{{columns.ACTION_REPEAT}}">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{columns.ACTION_REPEAT}}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.reactionMultiplier }}
        </mat-cell>
      </ng-container>

      <!-- ACTIONS COLUMN -->
      <ng-container matColumnDef="{{columns.ACTIONS}}">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button
            mat-flat-button
            class="action-button icon-button"
            [routerLink]="[
            '/behavior-codes',
            row.behaviorCode.id,
            'behavior-code-reaction',
            row.id,
          ]">
            <fa-icon [icon]="['fas', 'pencil']"></fa-icon>
          </button>
          <button *ngIf="hasPrivilegeToDelete"
            mat-flat-button
            [disabled]="row.reactionType === 'default'"
            class="action-button icon-button"
            (click)="deleteReactionFromBehavior(row)">
            <fa-icon [icon]="['fas', 'trash']"></fa-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns;"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <
      <!-- Loading Bar Rows -->
      <ng-container matColumnDef="Loading">
        <mat-header-cell *matHeaderCellDef>
          <mat-progress-bar
            *ngIf="isLoading"
            color="primary"
            mode="indeterminate"></mat-progress-bar>
        </mat-header-cell>
        <mat-footer-cell *matFooterCellDef>
          <mat-progress-bar
            *ngIf="isLoading"
            color="primary"
            mode="indeterminate"></mat-progress-bar>
        </mat-footer-cell>
      </ng-container>
      <mat-header-row
        *matHeaderRowDef="isLoading ? ['Loading'] : []"
        class="loading-header"
        [class.hidden-row]="!isLoading"></mat-header-row>
      <mat-footer-row
        *matFooterRowDef="isLoading ? ['Loading'] : []"
        class="loading-footer"
        [class.hidden-row]="!isLoading"></mat-footer-row>

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef>
          No reactions found
        </mat-footer-cell>
      </ng-container>
      <mat-footer-row
        *matFooterRowDef="dataArr?.length || isLoading ? [] : ['noData']"
        class="empty-footer"
        [class.hidden-row]="dataArr?.length || isLoading"></mat-footer-row>
    </mat-table>
  </div>
  <div
    *ngIf="tableFilters.count > tableFilters.itemsPerPage"
    class="table-filters-bottom">
    <app-pagination
      *ngIf="showPagination"
      [tableFilters]="tableFilters"
      (tableFiltersUpdated)="updateTableFilters($event)"></app-pagination>
  </div>
</div>
